import { GET_INTERNSHIPS_STRUCTS_EMPLOYEES } from "../../../../enums/Request/request.types";

export const getInternshipsStructsEmployeesAction = (data) => {
    return {
        type: GET_INTERNSHIPS_STRUCTS_EMPLOYEES,
        payload: data,
    };
};
